var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeature6Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 922,
    height: 383.58267,
    viewBox: "0 0 922 383.58267",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M357.25768,124.17456c9.82-2.21144,20.46933,5.60902,21.86155,15.47538,1.67992,11.90518-9.33752,21.04997-18.25841,26.68709-9.81564,6.20252-20.46564,11.74437-25.87071,22.58807-4.67116,9.37134-5.34811,20.78176-1.50711,30.55881,7.43453,18.9242,28.68787,25.43715,42.79221,38.08015,3.44869,3.09137,6.5084,6.6117,8.72433,10.69684,2.90836,5.36164,4.09888,11.48003,3.82471,17.54972-.55815,12.3565-7.24631,23.38479-16.32625,31.45277-9.35053,8.30842-22.11576,12.49116-30.02448,22.44933-3.39121,4.27-5.95997,9.66944-5.57717,15.24857,.33127,4.82814,2.72647,9.58599,6.67698,12.44663,1.92429,1.39341,4.14281,2.17371,6.50715,2.34651,1.44461,.10558,1.43791-2.14491,0-2.25-5.15228-.37656-8.98394-4.75068-10.36761-9.47621-1.61122-5.50263,.35869-11.16379,3.57415-15.6857,3.66269-5.15084,8.93101-8.79791,14.23101-12.08711,5.37177-3.33374,10.83351-6.48509,15.65885-10.60648,9.0395-7.72076,15.93959-18.21925,17.55739-30.15375,.82057-6.05334,.3189-12.34781-1.841-18.08721-1.7345-4.609-4.47697-8.73505-7.83375-12.32109-6.58059-7.03004-15.073-11.90445-23.05305-17.13855-7.98531-5.23756-16.1549-11.13469-20.79309-19.72624-5.08289-9.41529-5.238-21.31916-.82445-31.02,2.36291-5.19359,5.97563-9.47738,10.42203-13.0215,4.84267-3.85998,10.32951-6.81025,15.53991-10.12544,9.07388-5.77339,18.82171-14.21342,19.14937-25.85042,.27761-9.85932-8.08432-18.77352-17.58965-20.38407-2.42385-.41069-4.85183-.35602-7.25107,.18428-1.41201,.31798-.81443,2.48774,.59814,2.16963h0Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.74232,125.17456c-9.82-2.21144-20.46933,5.60902-21.86155,15.47538-1.67992,11.90518,9.33752,21.04997,18.25841,26.68709,9.81564,6.20252,20.46564,11.74437,25.87071,22.58807,4.67116,9.37134,5.34811,20.78176,1.50711,30.55881-7.43453,18.9242-28.68787,25.43715-42.79221,38.08015-3.44869,3.09137-6.5084,6.6117-8.72433,10.69684-2.90836,5.36164-4.09888,11.48003-3.82471,17.54972,.55815,12.3565,7.24631,23.38479,16.32625,31.45277,9.35053,8.30842,22.11576,12.49116,30.02448,22.44933,3.39121,4.27,5.95997,9.66944,5.57717,15.24857-.33127,4.82814-2.72647,9.58599-6.67698,12.44663-1.92429,1.39341-4.14281,2.17371-6.50715,2.34651-1.44461,.10558-1.43791-2.14491,0-2.25,5.15228-.37656,8.98394-4.75068,10.36761-9.47621,1.61122-5.50263-.35869-11.16379-3.57415-15.6857-3.66269-5.15084-8.93101-8.79791-14.23101-12.08711-5.37177-3.33374-10.83351-6.48509-15.65885-10.60648-9.0395-7.72076-15.93959-18.21925-17.55739-30.15375-.82057-6.05334-.3189-12.34781,1.841-18.08721,1.7345-4.609,4.47697-8.73505,7.83375-12.32109,6.58059-7.03004,15.073-11.90445,23.05305-17.13855,7.98531-5.23756,16.1549-11.13469,20.79309-19.72624,5.08289-9.41529,5.238-21.31916,.82445-31.02-2.36291-5.19359-5.97563-9.47738-10.42203-13.0215-4.84267-3.85998-10.32951-6.81025-15.53991-10.12544-9.07388-5.77339-18.82171-14.21342-19.14937-25.85042-.27761-9.85932,8.08432-18.77352,17.58965-20.38407,2.42385-.41069,4.85183-.35602,7.25107,.18428,1.41201,.31798,.81443,2.48774-.59814,2.16963h0Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "753 60.58267 748.36098 92.36142 723 92.88977 723 65.16368 753 60.58267",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "753 60.58267 748.76672 93.36142 723.40574 93.88977 723.40574 66.16368 753 60.58267",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.50995,
    y: 237.3378,
    width: 8.98201,
    height: 145.29726,
    transform: "translate(226.00192 619.97285) rotate(-180)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.438,
    y: 237.3378,
    width: 8.98201,
    height: 145.29726,
    transform: "translate(297.85802 619.97285) rotate(-180)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.44349,
    y: 237.3378,
    width: 8.98201,
    height: 145.29726,
    transform: "translate(409.869 619.97285) rotate(-180)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.35081,
    y: 237.3378,
    width: 8.98201,
    height: 145.29726,
    transform: "translate(443.68364 619.97285) rotate(-180)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.75477,235.22438l-12.2228-63.47969c-2.24709-11.67035,5.86749-22.80025,17.66585-24.23035l65.35634-7.92198s8.98201,73.44116,8.98201,69.74269,89.0276,9.24619,55.74131,27.73857c-33.28628,18.49238-123.10641,13.20884-135.52272-1.84924Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.34537 343.56014 260.41353 354.62831 275.69814 362.53414 274.11697 376.23758 245.12892 373.07525 241.43953 365.69647 242.49364 359.37181 240.38542 349.35775 249.34537 343.56014",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.00875,370.96703l.90514-11.62795,31.24524,14.79028s2.41947,6.85172-5.11493,7.90583c-7.5344,1.05411-57.60467,1.05411-57.60467-1.58117,0-2.63528-1.36951-16.12707-1.36951-16.12707l30.35756,8.74829,1.58117-2.10822Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.53625 312.81751 201.53057 326.26807 197.6272 343.0277 183.95585 344.86576 179.89081 315.99046 186.1354 310.59946 192.52504 310.0655 201.71287 305.55888 209.53625 312.81751",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.54591,341.5259l11.49334-1.98281-6.65046,33.92328s-6.0461,4.03047-8.92107-3.01318c-2.87497-7.04364-15.1908-55.57561-12.63648-56.22381s15.29474-5.29423,15.29474-5.29423l-1.01244,31.57672,2.43237,1.01403Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.81834 61.13184 173.23328 93.36142 198.59426 93.88977 198.59426 66.16368 174.81834 61.13184",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.81834 61.13184 173.23328 93.36142 198.59426 93.88977 198.59426 66.16368 174.81834 61.13184",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.02169,194.27697s-11.62378,30.11616-3.17012,42.26829c8.45366,12.15213,48.08019,19.02073,48.08019,19.02073l16.37896,15.32226,43.325,83.47988,25.36098-5.81189-35.92805-85.5933s-21.13415-34.34299-29.05945-39.09817c-7.92531-4.75518-22.68275-22.60896-22.68275-22.60896l-42.30475-6.97884Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.87779,196.91874l16.27551,11.52601s57.69401,15.42002,39.20163,51.34807c-18.49238,35.92805-45.96677,61.81738-45.96677,61.81738l-24.30427-13.7372,39.09817-54.94878-68.68598-41.73994,44.38171-14.26555Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-32c083fa-d2b9-413a-9921-933cc214e28e-555",
    d: "M351.81173,153.10675c7.64814,1.53882,13.05361,6.73239,12.07349,11.59956-.98011,4.86717-7.97387,7.56406-15.62453,6.02367-3.06457-.5734-5.94726-1.87237-8.40688-3.78824l-32.32316-6.92927,2.77276-12.77513,32.28762,6.1102c3.01024-.81551,6.17204-.89808,9.22071-.24078Z",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-3df95b4d-9d99-4974-98f2-e22ed77160d1-556",
    d: "M229.75627,235.66065c5.58996,5.44191,7.31321,12.7373,3.84936,16.29422-3.46385,3.55692-10.80203,2.02821-16.39326-3.41638-2.2633-2.14426-3.98018-4.79935-5.00699-7.74316l-23.39372-23.3567,9.25994-9.22744,23.80822,22.64936c2.97117,.94804,5.67202,2.594,7.87645,4.8001Z",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.27337,82.00181h-32.87858l-24.18362,16.37896,2.11341,64.45915s4.419,16.1868-10.56707,31.17287c-8.98201,8.98201-5.81189,14.26555-5.81189,14.26555l53.36372,4.22683,31.9654-9.24619-11.62378-29.05945,2.11341-8.98201s21.6625-15.32226,17.96403-31.17287c-3.69848-15.85061-8.45366-48.60854-8.45366-48.60854l-14.00137-3.4343Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.28999,176.8413l-23.77592-78.19635s-12.15213-4.22683-17.43567,6.34024c-5.28354,10.56707,1.36249,50.98613,1.36249,50.98613l27.69697,45.70259,44.38171,33.81464,11.09543-12.15213-43.325-46.49512Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.62675,136.51172l-63.77757-51.11149s-12.41614,3.37342-10.80987,15.07806,29.91464,41.31048,29.91464,41.31048l48.66556,22.07968,55.72307,2.84701,2.29537-16.29461-62.01119-13.90914Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.87642,
    cy: 53.99907,
    r: 22.19085,
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 804.50804,
    y: 237.3378,
    width: 8.98201,
    height: 145.29726,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768.57998,
    y: 237.3378,
    width: 8.98201,
    height: 145.29726,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 712.57449,
    y: 237.3378,
    width: 8.98201,
    height: 145.29726,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.66718,
    y: 237.3378,
    width: 8.98201,
    height: 145.29726,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.24523,235.22438l12.2228-63.47969c2.24709-11.67035-5.86749-22.80025-17.66585-24.23035l-65.35634-7.92198s-8.98201,73.44116-8.98201,69.74269-89.0276,9.24619-55.74131,27.73857c33.28628,18.49238,123.10641,13.20884,135.52272-1.84924Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "672.65463 343.56014 661.58647 354.62831 646.30186 362.53414 647.88303 376.23758 676.87108 373.07525 680.56047 365.69647 679.50636 359.37181 681.61458 349.35775 672.65463 343.56014",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.99125,370.96703l-.90514-11.62795-31.24524,14.79028s-2.41947,6.85172,5.11493,7.90583,57.60467,1.05411,57.60467-1.58117,1.36951-16.12707,1.36951-16.12707l-30.35756,8.74829-1.58117-2.10822Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "646.46997 269.55914 639.95683 283.79246 628.3891 296.53251 634.65015 308.82412 660.71525 295.75058 661.5996 287.54839 658.40591 281.98846 656.8893 271.8679 646.46997 269.55914",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.78786,303.14923l-4.90363-10.5822-24.12526,24.75862s.12202,7.26533,7.55099,5.62559c7.42897-1.63974,54.3555-19.10206,53.43643-21.57188-.91907-2.46982-4.34089-15.59213-4.34089-15.59213l-25.4005,18.7864-2.21715-1.42441Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.97831,194.27697s11.62378,30.11616,3.17012,42.26829c-8.45366,12.15213-48.08019,19.02073-48.08019,19.02073l-16.37896,15.32226-43.325,83.47988-25.36098-5.81189,35.92805-85.5933s21.13415-34.34299,29.05945-39.09817c7.92531-4.75518,22.68275-22.60896,22.68275-22.60896l42.30475-6.97884Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.02967,208.31757l-18.73546-6.83548s-45.48807-38.69381-64.52958-3.05375c-19.04151,35.64006-24.71792,72.96134-24.71792,72.96134l25.11936,12.18302,22.97284-63.40571,73.38947,32.77152-13.4987-44.62093Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-f8e61c27-c57f-4b74-9b81-e5dadccc9125-557",
    d: "M639.40505,228.28888c-5.02211,5.96997-6.0126,13.40039-2.21275,16.59587,3.79985,3.19548,10.95002,.94583,15.97312-5.02693,2.03925-2.35835,3.48407-5.17077,4.21356-8.20197l20.95944-25.56372-10.13024-8.26258-21.44211,24.90102c-2.86237,1.23832-5.38648,3.14427-7.36101,5.55832Z",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-b8d4031a-9298-4827-ae0e-c4fc86cbbe53-558",
    d: "M692.24373,235.66065c-5.58996,5.44191-7.31321,12.7373-3.84936,16.29422,3.46385,3.55692,10.80203,2.02821,16.39326-3.41638,2.2633-2.14426,3.98018-4.79935,5.00699-7.74316l23.39372-23.3567-9.25994-9.22744-23.80822,22.64936c-2.97117,.94804-5.67202,2.594-7.87645,4.8001Z",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.72663,82.00181h32.87858l24.18362,16.37896-2.11341,64.45915s-4.419,16.1868,10.56707,31.17287c8.98201,8.98201,5.81189,14.26555,5.81189,14.26555l-53.36372,4.22683-31.9654-9.24619,11.62378-29.05945-2.11341-8.98201s-21.6625-15.32226-17.96403-31.17287,8.45366-48.60854,8.45366-48.60854l14.00137-3.4343Z",
    fill: "#06153a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.71001,176.8413l23.77592-78.19635s12.15213-4.22683,17.43567,6.34024c5.28354,10.56707-1.36249,50.98613-1.36249,50.98613l-27.69697,45.70259-44.38171,33.81464-11.09543-12.15213,43.325-46.49512Z",
    fill: "#06153a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.42418,167.20694l18.02234-79.71924s11.81232-5.09996,17.85084,5.0546,2.35151,50.9501,2.35151,50.9501l-24.29764,47.59699-41.80326,36.95474-11.95035-11.31247,39.82657-49.52471Z",
    fill: "#06153a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 125.58267,
    width: 7,
    height: 256,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.69775 161.1647 287.19775 109.18033 288.80225 107.98501 352.30225 159.96939 350.69775 161.1647",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,130.08267h-4c-6.89258,0-12.5-5.60742-12.5-12.5v-34c0-6.89258,5.60742-12.5,12.5-12.5h4c6.89258,0,12.5,5.60742,12.5,12.5v34c0,6.89258-5.60742,12.5-12.5,12.5Z",
    fill: "#06153a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.5,
    cy: 97.08267,
    rx: 18.5,
    ry: 30.5,
    fill: "#06153a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,114.58267c-10.72217,0-31-1.46289-31-7,0-2.71875,4.81152-4.73535,14.30078-5.99414l.2627,1.98242c-10.25537,1.36133-12.56348,3.40332-12.56348,4.01172,0,1.69727,10.23584,5,29,5s29-3.30273,29-5c0-.85449-3.53125-3.0166-14.4458-4.24121l.22266-1.98828c7.40088,.83105,16.22314,2.58594,16.22314,6.22949,0,5.53711-20.27783,7-31,7Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 594,
    y: 125.58267,
    width: 7,
    height: 256,
    transform: "translate(1195 507.16534) rotate(-180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "599.30225 161.1647 662.80225 109.18033 661.19775 107.98501 597.69775 159.96939 599.30225 161.1647",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.5,117.58267v-34c0-6.89258,5.60742-12.5,12.5-12.5h4c6.89258,0,12.5,5.60742,12.5,12.5v34c0,6.89258-5.60742,12.5-12.5,12.5h-4c-6.89258,0-12.5-5.60742-12.5-12.5Z",
    fill: "#06153a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 663.5,
    cy: 97.08267,
    rx: 18.5,
    ry: 30.5,
    fill: "#06153a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597,114.58267c-10.72217,0-31-1.46289-31-7,0-3.64355,8.82227-5.39844,16.22314-6.22949l.22266,1.98828c-10.91455,1.22461-14.4458,3.38672-14.4458,4.24121,0,1.69727,10.23584,5,29,5s29-3.30273,29-5c0-.6084-2.30811-2.65039-12.56348-4.01172l.2627-1.98242c9.48926,1.25879,14.30078,3.27539,14.30078,5.99414,0,5.53711-20.27783,7-31,7Z",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 736.02409,
    cy: 49.76989,
    r: 23.62477,
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.90956,18.00804c-.68361,.39905-1.59928-.2047-1.81848-.9653-.2192-.7606,.03614-1.56815,.28935-2.31812l1.27468-3.77542c.90403-2.67762,1.86351-5.4488,3.82142-7.48681,2.95515-3.07605,7.65156-3.85859,11.87928-3.29167,5.42922,.72803,10.78599,3.6679,13.31042,8.52935,2.52443,4.86145,1.44968,11.64492-3.11179,14.67797,6.5011,7.45135,8.76729,15.75561,8.40947,25.63786-.35782,9.88225-11.12705,18.97714-18.15003,25.9388-1.56836-.95072-2.99417-5.40618-2.13172-7.02476,.86245-1.61858-.37325-3.49374,.69487-4.98462,1.06812-1.49088,1.96174,.88304,.88189-.59937-.6814-.93543,1.97808-3.08745,.96523-3.64732-4.89902-2.70801-6.5284-8.81443-9.6053-13.49058-3.71131-5.64031-10.06323-9.45998-16.78523-10.09367-3.70292-.34908-7.61402,.28317-10.64916,2.43291-3.03514,2.14974-5.00007,5.99129-4.29626,9.64343-1.82278-1.85078-2.73012-4.56311-2.38789-7.13814s1.92651-4.95622,4.16942-6.26666c-1.36379-4.50996-.19547-9.69774,2.96994-13.1877,3.16541-3.48996,16.00604-2.89556,20.6273-1.97706",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.62722,35.25129c6.12072,.66073,10.54005,5.96263,14.2718,10.85893,2.1509,2.82212,4.40394,5.93867,4.34994,9.48659-.05459,3.58705-2.4529,6.66372-3.59909,10.06316-1.87348,5.55648-.04755,12.1674,4.41217,15.97466-4.40671,.83623-9.17048-2.46792-9.93122-6.88829-.8856-5.14585,3.0152-10.11238,2.55323-15.3134-.40701-4.58216-4.01795-8.10867-7.08778-11.53475-3.06983-3.42607-5.95294-7.97238-4.54066-12.35043",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.50153,16.84809s-8.89548-6.42451-16.80257,7.4129c-5.40118,9.45206-8.26587,27.43594-9.53914,37.88549-.58601,4.80929,1.90736,9.46695,6.2285,11.65795l28.02029,14.20747s-10.37806-39.53545,3.95355-45.46577c14.3316-5.93032,13.83741-4.44774,13.83741-4.44774,0,0,11.36644,24.70966-3.45935,35.58191l12.35483,7.90709s8.40128-46.45416-6.9187-55.34963c-15.31999-8.89548-11.86064-15.31999-27.67482-9.38967Z",
    fill: "#2f2e41"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M921,383.58267H0v-2H921c.55228,0,1,.44771,1,1h0c0,.55229-.44771,1-1,1Z",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature6Svg);
export default __webpack_public_path__ + "static/media/feature6_svg.0f8a8b0044f4b100d70feaa1f11bf99e.svg";
export { ForwardRef as ReactComponent };